import { FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, BoxProps, ChevronLeftOutline, ChevronRightOutline, HStack } from '@bonusly/design-system';

import { PaginationParams } from '../../types/pagination';
import { PaginationButtons } from './pagination-buttons';

interface PaginationProps extends BoxProps {
	data: PaginationParams;
	setPaginationData?: SetStateAction<any>;
}

export const Pagination: FC<PaginationProps> = ({ data, setPaginationData, ...rest }) => {
	const { t } = useTranslation('admin_rewards');

	const handlePageSelection = (pageNumber?: number) => {
		setPaginationData({
			...data,
			page_number: pageNumber || 1,
		});
	};

	const paginationButtons = PaginationButtons(data, (event: { currentTarget: { id: any } }) => handlePageSelection(Number(event.currentTarget.id)));

	return (
		<Box role="navigation" aria-label={t('pagination.navigation_label')} data-testid="pagination" {...rest}>
			<HStack list-style="none" spacing={{ base: 3, md: 7 }} justifyContent="center">
				{data.page_previous && (
					<ChevronLeftOutline
						aria-label={t('pagination.previous_page_label')}
						color="text.default"
						onClick={() => handlePageSelection(data.page_previous)}
						role="button"
						size="sm"
					/>
				)}
				{data.page_count && data.page_count > 1 && paginationButtons}
				{data.page_next && (
					<ChevronRightOutline
						aria-label={t('pagination.next_page_label')}
						color="text.default"
						onClick={() => handlePageSelection(data.page_next)}
						role="button"
						size="sm"
					/>
				)}
			</HStack>
		</Box>
	);
};
